import React from "react"

export function hoverTintFromPost(post) {
  const s = `${post?.id ?? ''}:${post?.slug ?? ''}`;
  let x = 0;
  for (let i = 0; i < s.length; i++) {
    x = (x * 31 + s.charCodeAt(i)) >>> 0;
  }
  const k = 12;
  const hue = ((x % k) * (360 / k)) | 0;
  const sat = 66 + ((x >>> 4) % 4) * 6;
  const light = 40 + ((x >>> 8) % 3) * 5;
  return `hsla(${hue}, ${sat}%, ${light}%, 0.14)`;
}

function PostGridCard({
  post,
  href,
  figureClassName = "",
  titleTag: TitleTag = "h3",
  showSubtitle = true,
  showAuthor = true,
  imageOverlay = null,
  onImageLoad,
  onImageError,
}) {
  return (
    <article className="post-grid">
      <div
        className="post-wraper home-blog-card-stack"
        style={{ "--product-card-hover-overlay": hoverTintFromPost(post) }}
      >
        <a
          className="post-grid-link oi-flex oi-flex-column"
          href={href}
          title="View Details"
          target="_blank"
          rel="noopener noreferrer"
        >
          {post.cover_f && (
            <figure className={figureClassName} style={figureClassName ? undefined : { position: "relative" }}>
              <img
                className="lazyload blur"
                src={post.cover_f}
                data-original={post.cover_f}
                alt={post.title}
                ref={(node) => {
                  if (node?.complete && node.naturalHeight > 0 && onImageLoad) {
                    onImageLoad({ target: node })
                  }
                }}
                onLoad={onImageLoad}
                onError={onImageError}
                style={{ width: "100%" }}
              />
              {imageOverlay}
            </figure>
          )}
          <div className="info-slide text-slide-fix oi-flex oi-flex-column">
            <p className="zone h7">{post.label}</p>
            <TitleTag>{post.title}</TitleTag>
            {showSubtitle && post.subtitle && (
              <p className="subtile h5">{post.subtitle}</p>
            )}
            {showAuthor && (
              <p className="author h7">
                <strong>{post.author_name}</strong> | {post.author_sm}
              </p>
            )}
          </div>
        </a>
      </div>
    </article>
  );
}

export default PostGridCard;
